<h1 mat-dialog-title style="font: 400 24px / 32px Roboto, Helvetica Neue, sans-serif;">{{title}}</h1>
<mat-dialog-content style="padding-bottom: 0%;">
  <span style="font-size: 18px; font-weight: bold; color:black;">{{content}}</span>
  <mat-list role="list">
    <mat-list-item role="listitem" *ngFor="let vessel of vessels">{{vessel}}</mat-list-item>
  </mat-list>
</mat-dialog-content>

<!-- Confirm added vessels -->
<mat-dialog-actions>
  <button mat-stroked-button
          class="text-blue-button"
          type="button"
          (click)="dialogRef.close(false)">
    {{cancelButton}}
  </button>
  <span style="flex: 1 1 auto;"></span>
  <button mat-stroked-button
          class="text-button"
          type="submit"
          align="end"
          (click)="confirmClck()">
    {{confirmButton}}
  </button>
</mat-dialog-actions>
